import {Component} from 'react'
import PropTypes from 'prop-types'

import {ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight,} from 'react-feather'

export default class Pagination extends Component {
  static propTypes = {
    current: PropTypes.number.isRequired,
    onFirstClick: PropTypes.func.isRequired,
    onLastClick: PropTypes.func.isRequired,
    onNextClick: PropTypes.func.isRequired,
    onPreviousClick: PropTypes.func.isRequired,
    hasPrevious: PropTypes.bool.isRequired,
    hasNext: PropTypes.bool.isRequired,
    className: PropTypes.string,
  }

  static defaultProps = {
    className: ''
  }

  render() {
    const {current, hasNext, hasPrevious, onFirstClick, onLastClick, onNextClick, onPreviousClick} = this.props
    if (!hasNext && !hasPrevious) {
      return null
    }

    return (
      <nav aria-label="Pagination" className={this.props.className}>
        <ul className="pagination">
          <li className={`page-item ${!hasPrevious ? 'disabled' : ''}`}>
            <button onClick={onFirstClick} className="page-link d-flex align-items-center h-100">
              <ChevronsLeft size={24}/>
            </button>
          </li>
          <li className={`page-item ${!hasPrevious ? 'disabled' : ''}`}>
            <button disabled={!hasPrevious} onClick={onPreviousClick} className="page-link d-flex align-items-center h-100">
              <ChevronLeft size={20}/>
            </button>
          </li>
          <li className="page-item">
            <button disabled={true} className="page-link">{current}</button>
          </li>
          <li className={`page-item ${!hasNext ? 'disabled' : ''}`}>
            <button disabled={!hasNext} onClick={onNextClick} className="page-link d-flex align-items-center h-100">
              <ChevronRight size={20}/>
            </button>
          </li>
          <li className={`page-item ${!hasNext ? 'disabled' : ''}`}>
            <button onClick={onLastClick}  disabled={!hasNext} className="page-link d-flex align-items-center h-100">
              <ChevronsRight size={24}/>
            </button>
          </li>
        </ul>
      </nav>
    )
  }
}
